import { Outlet } from "react-router";

// /join/:token — renders for anonymous visitors ("Sign up to join Acme")
// and signed-in users ("Accept invite") alike, so it sits outside both
// the guest-only and the dashboard guards. Styled like the auth pages.
export default function JoinLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Outlet />
    </div>
  );
}
